import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from 'src/app/services/authentication/authentication.service';
import {verifiedInvalid} from 'src/app/shared/helpers';
import {forbiddenPassword} from '../../shared/password.validator';

@Component({
  selector: 'app-password-recovery',
  templateUrl: './password-recovery.component.html',
  styleUrls: ['./password-recovery.component.scss']
})
export class PasswordRecoveryComponent implements OnInit {

  newPasswordForm: FormGroup;
  showPassword = false;
  showSecondPassword = false;
  private codigo: string;
  private username: string;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
  ) {
  }

  ngOnInit(): void {
    this.codigo = this.route.snapshot.queryParamMap.get('codigo');
    this.username = this.route.snapshot.queryParamMap.get('username');
    this.authService.token = this.route.snapshot.queryParamMap.get('token');
    if (!this.codigo || !this.username) {
      this.router.navigate(['login']);
    }
    this.newPasswordForm = this.fb.group({
      password: ['', [Validators.required]],
      secondPassword: ['', [Validators.required]]
    });
    this.newPasswordForm.get('password').addValidators(forbiddenPassword());
    this.newPasswordForm.get('secondPassword').addValidators(forbiddenPassword(13, this.newPasswordForm.get('password')));
    this.newPasswordForm.get('password').valueChanges.subscribe(
      () => this.newPasswordForm.get('secondPassword').updateValueAndValidity());
  }

  get invalidPassword(): boolean {
    return verifiedInvalid(this.newPasswordForm.get('password'));
  }

  get invalidSecondPassword(): boolean {
    return verifiedInvalid(this.newPasswordForm.get('secondPassword'));
  }
  get passwordErrors(): ValidationErrors {
    return this.newPasswordForm.get('password').errors;
  }
  get confirmPasswordErrors(): ValidationErrors {
    return this.newPasswordForm.get('secondPassword').errors;
  }
  get password(): AbstractControl {
    return this.newPasswordForm.get('password');
  }

  async submit() {
    const request = {
      codigo: this.codigo,
      username: this.username,
      contrasena: this.newPasswordForm.get('password').value
    };
    try {
      const response = await this.authService.createNewPassword(request);
      if (response.status === 'Ok') {
        this.router.navigate(['exito-reestablecer']);
      }
    } catch (error) {
      console.log('error al reestablecer contraseña: ', error);
    }
  }
}
